export default __webpack_public_path__ + "static/media/header.83b70162.png";